export default function HWY_TradeMedia() {
  this.init = () => {
    jQuery(document).ready(function ($) {
      $(".wines-carousel").owlCarousel({
        loop: true,
        nav: false,
        autoWidth: true,
        margin: 35,
        dots: false,
        responsive: {
          0: {
            center: true,
          },
          800: {
            center: false,
          },
        },
      });
      checkClasses();
      $(".wines-carousel").on("translated.owl.carousel", function (event) {
        checkClasses();
      });
      triggerSlider(".section-wine", ".wines-carousel");
      //   sliderPost();
      //   jQuery(window).on("resize", () => sliderPost());
      $(".nav-main-mobile .nav-main-mobile-container").click(function () {
        $(".nav-main-mobile .sidebar-menu").addClass("active");
      });
      $(".sidebar-menu-close").click(function () {
        $(".nav-main-mobile .sidebar-menu").removeClass("active");
      });
      $(".sidebar-menu-main a").click(function () {
        $(".nav-main-mobile .sidebar-menu").removeClass("active");
      });
      $(window).scroll(function () {
        var sticky = $(".hwy__nav-sticky .nav-main");
        if (sticky.length == 0) {
          return;
        }
        var scroll = $(this).scrollTop();
        if (scroll > $(".hwy__nav-sticky").position().top) {
          sticky.addClass("active");
        } else {
          sticky.removeClass("active");
        }
      });
    });
  };
  const checkClasses = () => {
    jQuery(document).ready(function ($) {
      var total = $(".wines-carousel .owl-stage .owl-item.active").length;

      $(".wines-carousel .owl-stage .owl-item").removeClass(
        "first-active-item last-active-item"
      );

      $(".wines-carousel .owl-stage .owl-item.active").each(function (index) {
        if (index === 0) {
          $(this).addClass("first-active-item");
        }
        if (index === total - 1 && total > 1) {
          $(this).addClass("last-active-item");
        }
      });
    });
  };
  const triggerSlider = (section, slider) => {
    jQuery(document).ready(function ($) {
      $(section + " .slider-control .btn-prev").click(function () {
        $(slider).trigger("prev.owl.carousel");
      });
      $(section + " .slider-control .btn-next").click(function () {
        $(slider).trigger("next.owl.carousel");
      });
    });
  };
}
